import React from "react"
import {
    Card,
    Intent,
    PopoverInteractionKind,
    PopoverPosition,
} from "@blueprintjs/core"
import {Popover2, Tooltip2} from "@blueprintjs/popover2"
import {useDispatch, useSelector} from "react-redux"
import {useTranslation} from "react-i18next"
import {
    dataClean,
    loadDateTableDataAction,
    loadDetectabilitySummaryDataAction,
    loadReferenceRangesInternalDataAction,
    setGenerateTableType,
} from "../../redux/refdb.actions"
import MinimalButton from "../../../core/components/buttons/MinimalButton"
import {getMultiContext} from "../../redux/refdb.selector"
import GenerateTableType from "../../../shared/enums/generateTableType"
import ActionButton from "../../../core/components/buttons/ActionButton"
import Filter from "../../models/filter"

const GenerateTableCard: React.FC<any> = () => {
    const {t} = useTranslation()
    const dispatch = useDispatch()
    const multiContext = useSelector(getMultiContext)

    const loadReferenceRangesData = () => {
        console.log("Load data...")
        dispatch(dataClean())
        dispatch(setGenerateTableType(GenerateTableType.referenceRanges))
        dispatch(loadReferenceRangesInternalDataAction())
    }

    const loadDateTableData = () => {
        console.log("Load data...")
        dispatch(dataClean())
        dispatch(setGenerateTableType(GenerateTableType.dataTable))
        dispatch(loadDateTableDataAction(false))
    }
    const loadDetectabilitySummaryData = () => {
        console.log("Load data...")
        dispatch(dataClean())
        dispatch(setGenerateTableType(GenerateTableType.detectabilitySummary))
        multiContext.forEach((context) => {
            dispatch(loadDetectabilitySummaryDataAction(context.index))
        })
    }

    const moreThenOneSubset = () => {
        return multiContext.length > 1
    }

    function mandatoryFieldsEmpty() {
        const count = multiContext.filter((context) => {
            return (
                Filter.isEmptyValues(context.assay.value) ||
                Filter.isEmptyValues(context.material) ||
                Filter.isEmptyValues(context.species)
            )
        }).length
        return count > 0
    }

    function anyFilterInvalid() {
        const filtersValidInEachContext = multiContext.map((context) => {
            return (
                context.filters.filter((filter) => !Filter.isValid(filter))
                    .length > 0
            )
        })

        return (
            filtersValidInEachContext.filter(
                (contextValid) => contextValid === true
            ).length > 0
        )
    }

    return (
        <Tooltip2
            content={t("Calculate data")}
            position={PopoverPosition.BOTTOM}
        >
            <Popover2
                className="DisplayDataConfigBarElement"
                interactionKind={PopoverInteractionKind.CLICK}
                position={PopoverPosition.BOTTOM_LEFT}
                modifiers={{arrow: {enabled: true}}}
                disabled={mandatoryFieldsEmpty() || anyFilterInvalid()}
                content={
                    <Card>
                        <div className="CardRow">
                            <ActionButton
                                intent={Intent.NONE}
                                className="CardRowElement ag-row-selected"
                                text="Calculate reference ranges"
                                disabled={moreThenOneSubset()}
                                onClick={loadReferenceRangesData}
                            />
                        </div>
                        <div className="CardRow">
                            <ActionButton
                                intent={Intent.NONE}
                                className="CardRowElement ag-row-selected"
                                text="Generate data table"
                                disabled={moreThenOneSubset()}
                                onClick={loadDateTableData}
                            />
                        </div>
                        <div className="CardRow">
                            <ActionButton
                                intent={Intent.NONE}
                                className="CardRowElement ag-row-selected"
                                text="Generate detectability summary"
                                onClick={loadDetectabilitySummaryData}
                            />
                        </div>
                    </Card>
                }
            >
                <MinimalButton
                    text="Generate table"
                    rightIcon="caret-down"
                    disabled={mandatoryFieldsEmpty() || anyFilterInvalid()}
                />
            </Popover2>
        </Tooltip2>
    )
}

export default GenerateTableCard
